import React, { useEffect, useState } from "react";
import AiMarkdown from "../AiAssistant/AiMarkdown";
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from "../../ui/dialog";

/** Markdown text on the report: headings between sections, explanations, links. */
export const NoteContent: React.FC<{ text: string; className?: string }> = ({
	text,
	className,
}) => (
	<div className={className}>
		{text.trim() ? (
			<AiMarkdown className="report-note [&_h1]:text-xl [&_h1]:font-semibold [&_h2]:text-lg [&_h2]:font-semibold [&_h3]:text-base [&_h3]:font-semibold">
				{text}
			</AiMarkdown>
		) : (
			<p className="text-sm italic text-gray-400">Tom anteckning</p>
		)}
	</div>
);

interface NoteDialogProps {
	open: boolean;
	onOpenChange: (open: boolean) => void;
	initialText?: string;
	onSave: (text: string) => void;
}

const NoteDialog: React.FC<NoteDialogProps> = ({ open, onOpenChange, initialText, onSave }) => {
	const [text, setText] = useState(initialText ?? "");
	useEffect(() => {
		if (open) setText(initialText ?? "");
	}, [open, initialText]);
	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent className="z-[1300] w-[min(40rem,calc(100vw-2rem))] max-w-none">
				<DialogHeader>
					<DialogTitle>
						{initialText === undefined ? "Ny anteckning" : "Ändra anteckning"}
					</DialogTitle>
					<DialogDescription>
						Markdown fungerar: ## Rubrik för en sektion, **fet**, listor och länkar.
					</DialogDescription>
				</DialogHeader>
				<textarea
					value={text}
					onChange={(e) => setText(e.target.value)}
					rows={8}
					autoFocus
					placeholder="## Ekonomi&#10;Siffrorna nedan gäller fakturerade pass."
					className="w-full rounded-md border border-gray-300 p-2 font-mono text-sm focus:border-brand focus:outline-none"
				/>
				<DialogFooter>
					<button
						type="button"
						onClick={() => onOpenChange(false)}
						className="rounded-md border px-3 py-1.5 text-sm"
					>
						Avbryt
					</button>
					<button
						type="button"
						onClick={() => {
							onSave(text);
							onOpenChange(false);
						}}
						className="rounded-md bg-gray-900 px-3 py-1.5 text-sm font-medium text-white"
					>
						Spara
					</button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
};

export default NoteDialog;
